module.exports = __webpack_public_path__ + "img/bda1b23.jpg";